/*!

=========================================================
* Vue Argon Dashboard - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vue-argon-dashboard
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/vue-argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import ArgonDashboard from "./plugins/argon-dashboard";
import "element-plus/lib/theme-chalk/index.css";
import 'moment/locale/fr'

import axios from 'axios';
import Vuex from 'vuex';
import store from './store';
import ApiResource from './plugins/apiResources';
import {
  AUTH_LOGOUT
} from "./store/actions/auth";

axios.defaults.baseURL = window.APP_CONFIG?.apiUrl ?? process.env.VUE_APP_API_URL;

const token = localStorage.getItem('user-token')
if (token) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

axios.interceptors.response.use(response => {
  return response;
}, error => {
 if (error.response.status === 401) {
   store.dispatch(AUTH_LOGOUT);
   router.push('/login');
 }
 return Promise.reject(error);
});

const appInstance = createApp(App);
appInstance.use(Vuex);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(store);
appInstance.use(ApiResource);
appInstance.mount("#app");
